/* The site logo, on both page families.

   Rockkt pages. Every logo on the hand built templates, header and footer, is
   `<img data-media="m0">`, filled in from `window.RKMEDIA.m0` inside
   rockkt-media.js. That file is 1.4MB of base64 keyed m0 to m43 and cannot be
   edited through the Admin API, so the new logo is an ordinary theme asset and
   this points the images at it instead. The URL is handed over from Liquid,
   hence the global.

   Three passes, because three different things set that src and they do not all
   run at the same moment:

     - the homepage does it in an inline script during parse
     - rockkt-page-v1.js does it again on load, though only for images that have
       no src yet, so it will not fight this
     - rockkt-footer-sync-v1.js can rebuild the footer after both

   Hence DOMContentLoaded, load, and an observer for anything added later. Each
   pass is a no-op once the image is already ours.

   Dawn pages. Products, cart, account, 404, Client Zone and Mission Control use
   layout/theme.liquid, whose header renders `settings.logo` through the
   image_tag filter. That is a different image and a different element, so it
   needs its own rule: .header__heading-logo. srcset and sizes have to be
   cleared as well as src, or the browser goes on choosing a candidate from the
   old set and the swap does nothing.

   v3 adds the Dawn half. v2 fixed the stretched footer logo and that reasoning
   still holds: the width and height attributes exist only to give the browser
   an aspect ratio to reserve, but an attribute width is a real used value, and
   the footer rule `.foot-brand img{height:34px}` sets no width, so the footer
   took the attribute literally and drew the logo full width at 34px tall. The
   attributes carry the asset's true pixel size and an inline width:auto makes
   every copy scale from height whatever the stylesheet says. */
(function () {
  var SRC = window.RK_LOGO_SRC;
  if (!SRC) return;

  var W = 356, H = 56;          /* rk-logo-3d-v1.webp, natural size */

  /* m2 is the Rockkt One mock's own sidebar logo on the homepage. It is a
     different key in rockkt-media.js, holding the old flat lockup, and it was
     the last place on the site still showing it — every other rule and selector
     for the new logo names m0 and never reached it. Same picture, same
     width:auto treatment; its height stays with .qs-head .qs-logo in
     rockkt-home-v2.css, which is two classes and outranks anything here. */
  var SEL = 'img[data-media="m0"], img[data-media="m2"], img.header__heading-logo';

  function take(el) {
    if (el.getAttribute('data-rk-logo') === '3') return;
    el.setAttribute('data-rk-logo', '3');
    el.removeAttribute('srcset');
    el.removeAttribute('sizes');
    el.setAttribute('width', W);
    el.setAttribute('height', H);
    el.style.width = 'auto';
    el.src = SRC;
  }

  function swap(root) {
    var imgs = (root || document).querySelectorAll(SEL);
    for (var i = 0; i < imgs.length; i++) take(imgs[i]);
  }

  function run() { swap(document); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  window.addEventListener('load', run);

  /* The footer is assembled late on several templates, and Dawn re-renders its
     header into the page in the theme editor, so a logo that arrives after the
     last pass would otherwise keep the old picture. */
  function observe() {
    if (!('MutationObserver' in window) || !document.body) return;
    new MutationObserver(function (recs) {
      for (var i = 0; i < recs.length; i++) {
        for (var j = 0; j < recs[i].addedNodes.length; j++) {
          var n = recs[i].addedNodes[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && n.matches(SEL)) take(n);
          else if (n.querySelector && n.querySelector(SEL)) swap(n);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.body) observe();
  else document.addEventListener('DOMContentLoaded', observe);
})();
